import api from "./api";

//const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/documents/${employeeUniqueId}`);

export const beforeVerficationDocuments =async(employeeUniqueId)=>{
    const response = await api.get(`/api/documents/${employeeUniqueId}`);
    return response;
};

export const verficationFetchSubmitedResponse =async (employeeUniqueId)=>{
    const response = await api.get(`/api/verification/verification-status/${employeeUniqueId}`);
    return response.data
};
export const verificationUpdate= async (payload)=>{
    await api.post(`/api/verification/update`,payload);
}
export const verificationReview= async (reviewPayload)=>{
    await api.post(`/api/verification/review`,reviewPayload);
}